import { createDialog } from '@/infrastructure/decorators/dialog';
export function createTemplateLibraryDialog() {
    return createDialog(() => import('../../presentation/components/TemplateLibrary/TemplateLibraryDialog.vue'));
}
